import { service } from '@/utils/request'
// 科室分页
export function getDepartments(params) {
  return service({
    url: "/cloud/course/admin/knowledgeGraph/departments",
    method: 'get',
    params
  })
}

// 保存科室
export function saveDepartment(data) {
  return service({
    url: "/cloud/course/admin/knowledgeGraph/saveDepartment",
    method: 'post',
    data
  })
}

// 科室上下架
export function changeStateDepartment(params) {
  return service({
    url: "/cloud/course/admin/knowledgeGraph/changeStateDepartment",
    method: 'post',
    params
  })
}

// 科室删除
export function deleteDepartment(params) {
  return service({
    url: "/cloud/course/admin/knowledgeGraph/deleteDepartment",
    method: 'post',
    params
  })
}

// 病种分页
export function getDisease(params) {
  return service({
    url: '/cloud/course/admin/knowledgeGraph/diseasePages',
    method: 'get',
    params
  })
}
// 保存病种
export function saveDisease(data) {
  return service({
    url: '/cloud/course/admin/knowledgeGraph/saveDisease',
    method: 'post',
    data
  })
}

// 病种详情
export function diseaseDetails(params) {
  return service({
    url: '/cloud/course/admin/knowledgeGraph/diseaseDetails',
    method: 'get',
    params
  })
}

// 病种上下架
export function changeStateDisease(params) {
  return service({
    url: '/cloud/course/admin/knowledgeGraph/changeStateDisease',
    method: 'post',
    params
  })
}

// 病种删除
export function deleteDisease(params) {
  return service({
    url: '/cloud/course/admin/knowledgeGraph/deleteDisease',
    method: 'post',
    params
  })
}

// 加入人员列表
export function joinUserPages(params) {
  return service({
    url: '/cloud/course/admin/knowledgeGraph/joinUserPages',
    method: 'get',
    params
  })
}

// UV人员列表
export function uvUserPages(params) {
  return service({
    url: '/cloud/course/admin/knowledgeGraph/uvUserPages',
    method: 'get',
    params
  })
}

// 导出UV/加入人员列表
export function exportUserExcel(params) {
  return service({
    url: '/cloud/course/admin/knowledgeGraph/exportUserExcel',
    method: 'get',
    params,
    responseType: 'blob'
  })
}



// WEBPACK FOOTER //
// ./src/api/contentManage/mapping.js